import { useEffect } from 'react'

function AuthPage({ root }) {
  useEffect(() => {
    if (window.location.search) {
      const params = new URLSearchParams(window.location.search)
      localStorage.setItem('jwt-token', params.get('token'))
      let redirectPath = params.get('redirectPath')
      window.location.assign(redirectPath ? redirectPath : root)
    }
  }, [])

  return (<>Authenticating...</>)
}

export default AuthPage
